import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import withPagination, { PaginationProps } from "app/utils/withPagination";
import ConfigurableTable from "app/components/AppComponents/ConfigurableTable";
import walletSpendColumns from "./walletSpendColumns";

type Props = {
  name: string;
  createdAtFrom: string;
  createdAtTo: string;
};

const query = gql`
  query walletSpendList(
    $created_at_from: String
    $created_at_to: String
    $offset: Int
    $limit: Int
  ) {
    payments(
      psp: "wallet"
      offset: $offset
      limit: $limit
      created_at_from: $created_at_from
      created_at_to: $created_at_to
    ) {
      created_at
      device {
        external_reference
        phone_number
        snapmin_url
        user {
          email
          external_reference
          snapmin_url
        }
      }
      merchant {
        id
        snapmin_url
        name
      }
      payable_amount
      snapmin_url
      status
    }
  }
`;

const withData = graphql<any, Props & PaginationProps>(query, {
  options: ({ createdAtFrom, createdAtTo, pagination: { offset, limit } }) => ({
    fetchPolicy: "network-only",
    variables: {
      created_at_from: createdAtFrom,
      created_at_to: createdAtTo,
      offset,
      limit
    }
  })
});

export default withPagination(
  withData(props => (
    <BOGraphQLLoader data={props.data}>
      <ConfigurableTable
        columnConfigs={walletSpendColumns}
        defaultColumns={["User", "Merchant", "Device", "Payable amount"]}
        rows={props.data.payments || []}
        pagination={props.pagination}
        name={props.name}
      />
    </BOGraphQLLoader>
  ))
);
